import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, ExternalLink, Quote } from "lucide-react";
import { api } from "../../lib/api";

export function Reviews({ compact = false }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/reviews").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || data.enabled === false || !data.rating) return null;
  const list = compact ? data.reviews.slice(0, 3) : data.reviews;

  return (
    <section data-testid="reviews-section" className="py-24 md:py-32 bg-[#F1F5F0]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="text-[#62B848] font-bold tracking-wide uppercase text-sm mb-3">What Perth says</p>
            <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#1A2421] leading-none">
              Rated {data.rating}★ by<br />homeowners & property managers
            </h2>
          </div>
          <div className="flex items-center gap-5">
            <div className="text-center">
              <div className="font-display font-black text-5xl text-[#224733] leading-none">{data.rating}</div>
              <div className="flex gap-0.5 mt-1.5 text-[#62B848]">
                {[...Array(5)].map((_, i) => <Star key={i} size={15} fill="currentColor" />)}
              </div>
              <div className="text-xs text-[#4A5550] mt-1">{data.total} Google reviews</div>
            </div>
            <a href={data.place_url} target="_blank" rel="noreferrer" data-testid="leave-review-btn"
              className="inline-flex items-center gap-2 bg-[#224733] hover:bg-[#1A3626] text-white text-sm font-bold px-5 py-3 rounded-full transition-colors">
              Leave us a review <ExternalLink size={15} />
            </a>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {list.map((r, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }} transition={{ delay: i * 0.06 }}
              className="bg-white rounded-3xl border border-black/5 p-7 shadow-sm hover:shadow-xl transition-shadow">
              <Quote size={28} className="text-[#62B848]/40 mb-3" />
              <div className="flex gap-0.5 mb-3 text-[#62B848]">
                {[...Array(r.rating)].map((_, j) => <Star key={j} size={15} fill="currentColor" />)}
              </div>
              <p className="text-[#1A2421] leading-relaxed mb-5">{r.text}</p>
              <div className="flex items-center justify-between">
                <span className="font-bold text-[#1A2421]">{r.author}</span>
                <span className="text-xs text-[#4A5550]">{r.time}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
